import React, { useState } from 'react'
import {
  TableRow,
  TableCell,
  TableBody,
  Table,
  TableHead,
  TableContainer,
} from '@material-ui/core'
import Pagination from '../../Pagination/Pagination'
import { useDateFormatter } from '../../../hooks/useDateFormatter'
import ActionsMenu from '../../ActionsMenu/ActionsMenu'
import { MoreVert } from '@material-ui/icons'

const ProgramTable = ({
  programs,
  setProgramToEdit,
  setShowAddEditProgram,
  setProgramToDelete,
  setShowDeleteModal,
}) => {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(25)

  const Row = ({ program }) => {
    const handleEditProgram = () => {
      setProgramToEdit(program)
      setShowAddEditProgram(true)
    }

    const handleDeleteProgram = () => {
      setShowDeleteModal(true)
      setProgramToDelete(program)
    }
    return (
      <TableRow>
        <TableCell>{program.name}</TableCell>
        <TableCell>
          {program.programFiles.length + program.additionalFiles.length}
        </TableCell>
        <TableCell>
          {useDateFormatter(program.createdAt, 'MM-DD-YYYY')}
        </TableCell>
        <TableCell>
          {useDateFormatter(program.updatedAt, 'MM-DD-YYYY')}
        </TableCell>
        <TableCell>
          <ActionsMenu
            icon={<MoreVert />}
            options={[
              { onClick: handleEditProgram, label: 'Edit' },
              { onClick: handleDeleteProgram, label: 'Delete' },
            ]}
          />
        </TableCell>
      </TableRow>
    )
  }

  return (
    <>
      {programs !== undefined && (
        <TableContainer>
          <Table stickyHeader aria-label="custom pagination table">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Files uploaded</TableCell>
                <TableCell>Date added</TableCell>
                <TableCell>Last updated</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(rowsPerPage > 0
                ? programs.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
                : programs
              ).map((program, index) => (
                <Row key={index} program={program} />
              ))}
            </TableBody>
          </Table>
          <Pagination
            setRowsPerPage={setRowsPerPage}
            rowsPerPage={rowsPerPage}
            page={page}
            setPage={setPage}
            rows={programs}
          />
        </TableContainer>
      )}
    </>
  )
}

export default ProgramTable
